import { render, staticRenderFns } from "./OrganizationCard.vue?vue&type=template&id=1d10a30c&scoped=true&"
import script from "./OrganizationCard.vue?vue&type=script&lang=js&"
export * from "./OrganizationCard.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationCard.vue?vue&type=style&index=0&id=1d10a30c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d10a30c",
  null
  
)

export default component.exports